import React from 'react';
import { Info } from 'lucide-react';
const STEPS = [{
  num: '1',
  title: 'Request Your Free Estimate',
  copy: 'Submit the short form or call Kosin’s Glass.'
}, {
  num: '2',
  title: 'Share Basic Details',
  copy: 'A team member will ask what glass is damaged, where it is located, and whether you have rough width and height measurements in inches or photos.'
}, {
  num: '3',
  title: 'In-Home Measurement',
  copy: 'For approved projects, Kosin’s Glass comes out to take exact measurements. For shower projects, final measurements should happen after walls and tile are completed.'
}, {
  num: '4',
  title: 'Fabrication & Installation',
  copy: 'Your glass is ordered, fabricated or prepared, then professionally installed by experienced glass technicians.'
}];
export function Process() {
  return <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-170">
      <div className="max-w-7xl mx-auto" data-id="element-171">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-172">
          <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 tracking-tight" data-id="element-173">
            How Your Residential Glass Quote Works
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start" data-id="element-174">
          <ol className="lg:col-span-8 space-y-8" data-id="element-175">
            {STEPS.map((step, idx) => <li key={idx} className="flex gap-6 anim-on-scroll" data-id="element-176">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-brandBlue-100 text-brandBlue-700 flex items-center justify-center text-xl font-bold border-2 border-brandBlue-200" data-id="element-177">
                  {step.num}
                </div>
                <div data-id="element-178">
                  <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-179">
                    {step.title}
                  </h3>
                  <p className="text-slate-600 text-lg" data-id="element-180">{step.copy}</p>
                </div>
              </li>)}
          </ol>

          <aside className="lg:col-span-4" data-id="element-181">
            <div className="bg-softGreen-50 rounded-2xl p-6 border border-softGreen-100 shadow-sm" data-id="element-182">
              <div className="flex items-center gap-3 mb-4" data-id="element-183">
                <Info className="w-6 h-6 text-emerald-600" aria-hidden="true" data-id="element-184" />
                <h3 className="text-lg font-bold text-emerald-900" data-id="element-185">Tip</h3>
              </div>
              <p className="text-emerald-800 leading-relaxed" data-id="element-186">
                For a faster rough quote, measure the visible glass width and
                height in inches and take a clear photo of the window, door,
                shower, mirror, table top or glass project.
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>;
}